import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import { selectTheme, previousTheme, nextTheme } from "../../../modules/search";
import previousIcon from "../../../icons/previous.svg";
import nextIcon from "../../../icons/next.svg";
import "./InlineResult.css";

class ExtendResult extends Component {
  onChangeTheme = () => {
    console.log("select theme");
  };

  render() {
    return (
      <div className="inline-result-container">
        <div className="results-inline-container">
          {this.props.results.map(result => (
            <div
              tabIndex={0}
              role="button"
              onClick={() => this.props.selectTheme(result)}
              onKeyPress={() => this.props.selectTheme(result)}
              style={
                this.props.selectedTheme.id === result.id
                  ? { backgroundColor: result.color }
                  : { backgroundColor: "white" }
              }
              key={`inline-${result.id}`}
              className="icon-inline-container"
            >
              <img
                alt="icon"
                src={
                  this.props.selectedTheme.id === result.id
                    ? `../assets/theme/${result.id}.svg`
                    : `../assets/theme/${result.id}-inline.svg`
                }
              />
            </div>
          ))}
        </div>
        <div
          style={{ backgroundColor: this.props.selectedTheme.color }}
          className="inline-data-container"
        >
          <IconButton onClick={this.props.previousTheme}>
            <img className="icon-arrow" alt="previous" src={previousIcon} />
          </IconButton>
          <div className="time-selected-result">
            {this.props.selectedTheme.data[this.props.selectedResult].time /
              60 >=
              1 &&
              `${Math.floor(
                this.props.selectedTheme.data[this.props.selectedResult].time /
                  60
              )} h `}
            {this.props.selectedTheme.data[this.props.selectedResult].time % 60}{" "}
            min
          </div>
          <div className="divider" />
          <div className="distance-selected-result">
            {this.props.selectedTheme.data[this.props.selectedResult].distance}{" "}
            Km
          </div>
          <IconButton onClick={this.props.nextTheme}>
            <img className="icon-arrow" alt="next" src={nextIcon} />
          </IconButton>
        </div>
      </div>
    );
  }
}

ExtendResult.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          time: PropTypes.number,
          distance: PropTypes.number
        })
      )
    })
  ).isRequired,
  selectedTheme: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        time: PropTypes.number,
        distance: PropTypes.number
      })
    )
  }).isRequired,
  selectedResult: PropTypes.number.isRequired,
  selectTheme: PropTypes.func.isRequired,
  previousTheme: PropTypes.func.isRequired,
  nextTheme: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  results: state.search.results,
  selectedResult: state.search.selectedResult,
  selectedTheme: state.search.selectedTheme
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ selectTheme, previousTheme, nextTheme }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ExtendResult);



// WEBPACK FOOTER //
// ./src/containers/MainCard/InlineResult/InlineResult.jsx